import PurchaseTypesEnum from '@/common/enums/purchase-types.enum';
import { CurationType } from '@/common/models/package/CurationType.enum';
import Package from '@/common/models/package/Package';
import PackageType from '@/common/models/package/PackageType.enum';
import ErrorHandler from '@/ErrorHandler';
import API from '@/org-app/api';
import orgAppStore from '@/org-app/store';
import {
  createAuditAction,
  createDeleteAction,
  createGetAllAction,
  createGetOneAction,
  createPostAction,
  createPutAction,
} from '@/utils/ActionsUtils';
import i18n from '@/vueI18n';

import * as types from './mutation-types';

export default {
  createNewCuratedPackage({ commit }, pack = Package.createNew()) {
    pack.packageType = PackageType.CURATED;
    pack.mediaOwnerIDs = [];
    pack.purchaseType = PurchaseTypesEnum.NON_GUARANTEED;
    pack.exchangeID = orgAppStore.state.organization.exchangeID;
    pack.marketTargetedImpressionsOverridable = false;
    pack.demographicTargetsOverridable = false;
    pack.locationTargetsOverridable = false;
    pack.unitAssignmentsOverridable = false;
    pack.networksOverridable = false;
    pack.mediaTypesOverridable = false;
    pack.daypartOverridable = false;
    pack.curationType = CurationType.PUBLISHER_DEALS;

    commit(types.CREATE_CURATEDPACKAGE, pack);
    return Promise.resolve(pack);
  },
  getCuratedPackages: createGetAllAction(
    API.instance.getCuratedPackages,
    types.UPDATE_CURATEDPACKAGES_LIST,
    'messages.failedToGetCuratedPackages',
    false,
  ),
  getCuratedPackage: createGetOneAction(
    API.instance.getCuratedPackage,
    types.SAVE_CURATEDPACKAGE,
    'messages.failedToGetCuratedPackage',
  ),
  createCuratedPackages: createPostAction(
    API.instance.postCuratedPackages,
    types.SAVE_CURATEDPACKAGE,
    'messages.failedToCreateCuratedPackage',
  ),
  updateCuratedPackage: createPutAction(
    API.instance.putCuratedPackage,
    types.SAVE_CURATEDPACKAGE,
    'messages.failedToUpdateCuratedPackage',
  ),
  deleteCuratedPackage: createDeleteAction(
    API.instance.deleteCuratedPackage,
    types.DELETE_CURATEDPACKAGE,
    'messages.failedToDeleteCuratedPackage',
  ),
  getCuratedPackageAudit: createAuditAction(
    API.instance.getCuratedPackageAudit,
    'messages.failedToGetCuratedPackageAudit',
  ),
  async getCuratedPackageEstimatedDeliveryStatistics({ commit }, { params }) {
    return await API.instance.getCuratedPackageEstimatedDeliveryStatistics({ data: params }).catch(({ error }) => {
      const msg = i18n.global.t('messages.failedToGetEstimatedDeliveryStatistics');
      ErrorHandler.showError(msg, error);
      throw error;
    });
  },
  async getCurateUnitCo2eEmissionsByVenueType({ commit }, { params }) {
    return await API.instance.getCurateUnitCo2eEmissionsByVenueType({ data: params }).catch(({ error }) => {
      const msg = i18n.global.t('messages.failedToGetUnitCo2EmissionsByVenueType');
      ErrorHandler.showError(msg, error);
      throw error;
    });
  },
};
